<template>
  <div class="data-display" v-if="teachData && teachData.length">
    <div class="data-title">{{ menu.module_name }}</div>
    <div class="main-text">
      涵盖
      <span>{{ teachData.length }}</span>
      个专业数据
    </div>
    <div
      class="data-card"
      v-for="({ name, num, targetUrl }, i) in teachData"
      :key="i"
      :style="getCardStyle(i)"
    >
      <a
        :target="targetUrl ? '_blank' : '_self'"
        :href="targetUrl ? targetUrl : 'javascript:void(0)'"
      >
        <div class="content">
          <!-- <div class="count">{{ num }}<span>个</span></div> -->
          <div class="count">
            <count-to
              ref="countToRef"
              :autoplay="false"
              :startVal="0"
              :endVal="Number(num)"
              :decimals="0"
              :duration="1200"
            ></count-to>
            <span class="unit">个</span>
          </div>
          <div class="text">{{ name }}</div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import { CountTo } from 'vue3-count-to'

export default {
  components: {
    CountTo
  },
  props: {
    menu: Object,
    visible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.$refs.countToRef['0'].start()
          for (let i = 0; i < this.teachData.length; i++) {
            this.$refs.countToRef[i].start()
          }
        }
      }
    }
  },
  created() {
    this.getTeachData()
  },
  data() {
    return {
      teachData: []
    }
  },
  methods: {
    getCardStyle(index) {
      const total = this.teachData.length

      const { x, y } = this.calculateEllipsePosition(index, total)
      return {
        transform: `translate(calc(-50% + ${x}px), calc(-50% + ${y}px))`
      }
    },
    calculateEllipsePosition(index, total) {
      const baseSize = 480 // 椭圆长轴半径
      const angleOffset = (-Math.PI / 4) * 3 // 起始于正上方
      const angle = angleOffset + (index / total) * Math.PI * 2

      // 椭圆参数（水平半径a，垂直半径b）
      const a = baseSize
      const b = baseSize * 0.4 // 垂直压缩系数

      let offsetX = 0
      let offsetY = 0

      if (index == 0) {
        offsetX = 130
        offsetY = -60
      }

      if (index == 1) {
        offsetX = 130
        offsetY = -10
      }

      if (index == 2) {
        offsetX = 100
        offsetY = -20
      }

      if (index == 3) {
        offsetX = 20
        offsetY = 60
      }

      if (index == 4) {
        offsetX = -160
        offsetY = 60
      }

      if (index == 5) {
        offsetX = -130
        offsetY = 20
      }

      if (index == 6) {
        offsetX = -110
        offsetY = -40
      }

      if (index == 7) {
        offsetX = -20
        offsetY = -110
      }

      return {
        x: a * Math.cos(angle) + offsetX,
        y: b * Math.sin(angle) + offsetY
      }
    },
    async getTeachData() {
      const teachData = await this.$http.getTeachData({ num: this.menu.num })
      console.log('数据模块', teachData)
      this.teachData = this.handleUrl(teachData)
    },
    handleUrl(data) {
      const urlList = {
        10301: '/index.html?',
        10401: '/courseList.html?type=1&',
        10402: '/courseList.html?type=2&',
        10501: '/teacherList.html?',
        10601: '/live.html?',
        10701: '/notice.html?',
        30200: '/teachingCenterList.html?',
        13100: '/microSpecialtyList.html?'
      }
      // 点击导航跳转到对应taget_url,并传参
      const list = data.map(item => ({
        ...item,
        targetUrl:
          item.template == 1
            ? item.targetUrl
            : item.template == 2 && item.targetUrl
            ? `${urlList[item.functionId]}menuId=${item.menuId}&name=${item.name}`
            : ''
      }))
      return list
    }
  }
}
</script>

<style scoped lang="scss">
.data-display {
  width: 1440px;
  height: 680px;
  box-sizing: border-box;
  padding: 40px 60px 0;
  position: relative;
  .data-title {
    color: #1c212a;
    font-family: 'Alibaba PuHuiTi';
    font-size: 32px;
    font-weight: 700;
    &::before {
      content: '';
      display: inline-block;
      width: 4px;
      height: 24px;
      background-color: #194189;
      margin-right: 8px;
    }
  }

  .main-text {
    color: #1c212a;
    font-family: 'Alimama ShuHeiTi';
    font-size: 32px;
    font-weight: 700;
    letter-spacing: 0.64px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    white-space: nowrap;

    span {
      font-size: 48px;
      color: #194189;
      margin: 0 5px;
    }
  }

  .data-card {
    width: 160px;
    height: 136px;
    border-radius: 12px;
    border: 1px solid #fff;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(2.63px);
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 10;

    a {
      width: 100%;
      height: 100%;
      display: block;
      color: #1c212a;
      text-decoration: none;
      cursor: pointer;

      .content {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .count {
          span {
            font-family: 'DIN Alternate';
            font-size: 54px;
            font-weight: 700;
            color: #1c212a;
            &.unit {
              font-family: 'PingFang SC';
              font-size: 18px;
              font-weight: 400;
            }
          }
        }

        .text {
          font-family: 'PingFang SC';
          font-size: 18px;
          font-weight: 500;
          margin-top: 5px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 140px;
        }
      }
    }
  }
}
</style>
